var React = require('react');

function PlusSmall (props) {
    return React.createElement("svg",props,[React.createElement("line",{"strokeWidth":"2","strokeMiterlimit":"10","x1":"10","y1":"5","x2":"0","y2":"5","key":0}),React.createElement("line",{"strokeWidth":"2","strokeMiterlimit":"10","x1":"5","y1":"10","x2":"5","y2":"0","key":1})]);
}

PlusSmall.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"10px","height":"10px","viewBox":"0 0 10 10","enableBackground":"new 0 0 10 10","xmlSpace":"preserve"};

module.exports = PlusSmall;

PlusSmall.default = PlusSmall;
